import ActionButtons from './parts/ActionButtons'
import Details from './parts/Details'
import styles from './styles'
import { ContainerItem } from './types'
import ActionArea from '@/features/common/components/Overview/parts/ProductItem/parts/ActionArea'
import isEqual from 'lodash.isequal'
import { FC, memo } from 'react'
import { Pressable, View } from 'react-native'

interface CartContainerItemProps {
    containerItem: ContainerItem
    onDelete: (id: string) => void
    onChangeQuantity: (id: string, changeQuantity: number) => void
    expanded: boolean
    onToggle: () => void
    compact: boolean
}

const CartContainerItem: FC<CartContainerItemProps> = ({
    containerItem,
    onDelete,
    onChangeQuantity,
    expanded,
    onToggle,
    compact,
}) => {
    const testID = `cart-container-item-${containerItem.id}`

    return (
        <View style={[styles.card, compact && styles.cardCompact]} testID={testID}>
            <Pressable onPress={onToggle} aria-expanded={expanded} testID={`${testID}-pressable`}>
                <Details containerItem={containerItem} compact={compact} />
            </Pressable>
            <ActionArea
                expanded={expanded}
                testID={`${testID}-actionArea`}
                TailComponent={
                    <ActionButtons
                        decreaseDisabled={containerItem.quantity <= 1}
                        id={containerItem.id}
                        onDelete={onDelete}
                        onChangeQuantity={onChangeQuantity}
                    />
                }
            />
        </View>
    )
}

export default memo(CartContainerItem, isEqual)
